"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFiservTransactionConverter = void 0;
exports.IFiservTransactionConverter = {
    toFirestore(transaction) {
        return transaction;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const IFiservTransaction = {
            id: data.id,
            idEmpresa: data.idEmpresa,
            tipoDocumento: data.tipoDocumento,
            idDocumento: data.idDocumento,
            TransactionId: data.TransactionId,
            STransactionId: data.STransactionId,
            aprobado: data.aprobado,
            finalizadoManualmente: data.finalizadoManualmente,
            codigoRespuestaPos: data.codigoRespuestaPos,
            mensajeMostrar: data.mensajeMostrar,
            codigoAutorizacion: data.codigoAutorizacion,
            TransactionDateTimeyyyyMMddHHmmssSSS: data.TransactionDateTimeyyyyMMddHHmmssSSS,
            accion: data.accion,
            importeGravado: data.importeGravado,
            importeTotalFactura: data.importeTotalFactura,
            importeACobrar: data.importeACobrar,
            moneda: data.moneda,
            numeroFactura: data.numeroFactura,
            comprobante: data.comprobante,
            Quotas: data.Quotas,
            cancelada: data.cancelada,
            idFixedTransaccionCancela: data.idFixedTransaccionCancela,
            VoucherXML: data.VoucherXML,
            Plan: data.Plan,
            PosID: data.PosID,
            SystemId: data.SystemId,
            Branch: data.Branch,
            ClientAppId: data.ClientAppId,
            UserId: data.UserId,
            reversaRealizada: data.reversaRealizada,
            timestampIniciacion: data.timestampIniciacion,
            timestampTimeout: data.timestampTimeout,
            EmvApplicationId: data.EmvApplicationId,
            TicketNumber: data.TicketNumber,
            Acquirer: data.Acquirer,
            estado: data.estado,
            posImprimeVoucher: data.posImprimeVoucher,
            RemainingExpirationTime: data.RemainingExpirationTime,
            ResponseCodeAPI: data.ResponseCodeAPI,
            OriginalTransactionDateyyMMdd: data.OriginalTransactionDateyyMMdd,
            TaxRefund: data.TaxRefund,
        };
        return IFiservTransaction;
    }
};
